export default __webpack_public_path__ + "static/priority_High.31df933842720d6b205c8ac39dc52c0c.svg";